import { useState, useEffect, useRef } from "react";
import CountUp from "react-countup";
import Companyp from "../../assets/contactus/profile.jpg";
import bgimage from "../../assets/About/wind2.jpg";
import { companyDescription,companyDescription2, companyDescription3, companyDescription4, companyIntroduction } from "../content/content";
import "../../App.css"; // Only for animations

const CompanyHome = () => {
  const [key, setKey] = useState(0);
  const [endValue, setEndValue] = useState(13);
  const sectionRef = useRef(null);
  const statsRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [statsVisible, setStatsVisible] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setKey((prevKey) => prevKey + 1);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setStatsVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div
        className="md:h-screen h-[500px] hero-section mt-[-90px] relative flex flex-col overflow-hidden w-full motion-safe:animate-fadeIn bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${Companyp})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-20 border-l-4 md:border-l-8 border-t-4 md:border-t-8 border-white border-b-4 md:border-b-8 border-b-yellow-500 mt-32 md:mt-44 mx-auto md:ml-12 px-6 pb-8 md:pb-10 h-auto md:h-60 w-11/12 sm:w-80 motion-safe:animate-[fadeInUp_0.6s_ease-out]">
          <h3 className="text-5xl md:text-7xl font-sans text-white mt-[19px]">
            Company Profile
          </h3>
        </div>
      </div>

      {/* Company Description */}
    <div className="mt-20 mx-auto max-w-6xl px-6 md:px-0">
  <div className="flex flex-col md:flex-row items-start justify-between bg-white shadow-md rounded-lg p-8 md:p-10">
    
    {/* Heading Section */}
    <div className="w-full md:w-7/12 border-l-4 border-green-500 pl-4">
      <h2 className="text-2xl md:text-3xl font-bold font-sans text-gray-800 leading-snug text-center md:text-left">
        India’s One of the Biggest Pressmud based CBG Plants in India
      </h2>
    </div>

    {/* Description Section */}
    <div className="w-full md:w-5/12 mt-6 md:mt-0">
      <p className="text-gray-600 font-sans text-base md:text-sm leading-relaxed text-justify">
        {companyIntroduction}
      </p>
    </div>
  </div>
</div>

      {/* Animated Company Description */}
      <div
  ref={sectionRef}
  className={`w-11/12 md:w-11/12 mx-auto mt-8 text-gray-500 font-sans text-justify text-sm leading-loose mb-6 scroll-animation ${
    visible ? "visible" : ""
  }`}
>
<div className="group inline-block mb-4">
  <h2 className="text-2xl sm:text-3xl font-bold leading-tight text-black tracking-wide relative">
    Compressed Bio Gas (CBG)
    <span className="absolute left-0 bottom-0 w-0 h-1 bg-black transition-all duration-300 group-hover:w-full"></span>
  </h2>
</div>
  <p>{companyDescription}</p>
  

  <div className="group inline-block mb-4 mt-5">
  <h2 className="text-2xl sm:text-3xl font-bold leading-tight text-black tracking-wide relative">
    Retail Automation
    <span className="absolute left-0 bottom-0 w-0 h-1 bg-black transition-all duration-300 group-hover:w-full"></span>
  </h2>
</div>
  <p>{companyDescription2}</p>
 

  <div className="group inline-block mb-4 mt-5">
  <h2 className="text-2xl sm:text-3xl font-bold leading-tight text-black tracking-wide relative">
    Petroleum TT & Fuel Bowser Fabrication Unit
    <span className="absolute left-0 bottom-0 w-0 h-1 bg-black transition-all duration-300 group-hover:w-full"></span>
  </h2>
</div>
  <p>{companyDescription3}</p>

  <div className="group inline-block mb-4 mt-5">
  <h2 className="text-2xl sm:text-3xl font-bold leading-tight text-black tracking-wide relative">
     DEF Dispensers
    <span className="absolute left-0 bottom-0 w-0 h-1 bg-black transition-all duration-300 group-hover:w-full"></span>
  </h2>
</div>
 
  <p>{companyDescription4}</p>
</div>

      {/* Experience Section */}
      <div
        className="bg-fixed bg-cover bg-center text-white py-10"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.9)), url(${bgimage})`,
        }}
      >
        <div className="flex flex-col items-center max-w-screen-lg mx-auto text-center">
          <h3 className="text-3xl sm:text-4xl lg:text-5xl font-poppins">
            Years of experience
          </h3>
          <div className="text-5xl sm:text-6xl md:text-[100px] lg:text-[170px] font-bold text-yellow-200 mt-4">
            <CountUp start={0} end={endValue} duration={2.5} key={key} />+
          </div>
          <p className="text-sm sm:text-lg mt-4 max-w-xl">
            Backed by 13+ years of proven expertise in fabrication, dispenser systems, and IT automation, we combine engineering excellence with advanced technology to deliver high-performance, future-ready solutions.
          </p>
        </div>

        {/* Statistics Section with Animation */}
        {/* <div
          ref={statsRef}
          className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-10 px-4 sm:px-8 text-center scroll-animation ${
            statsVisible ? "visible" : ""
          }`}
        >
          <div className="motion-safe:animate-[fadeInUp_0.6s_ease-out]">
            <h3 className="text-4xl font-bold text-yellow-200">
              <CountUp start={0} end={1000} duration={2.5} key={key} />+
            </h3>
            <p className="text-sm mt-2">Registered Locations</p>
          </div>
          <div className="motion-safe:animate-[fadeInUp_0.6s_ease-out]">
            <h3 className="text-4xl font-bold text-yellow-200">
              <CountUp start={0} end={10} decimals={1} duration={2.5} key={key} /> million+
            </h3>
            <p className="text-sm mt-2">Litres of Fuel Delivered Accident-Free</p>
          </div>
          <div className="motion-safe:animate-[fadeInUp_0.6s_ease-out]">
            <h3 className="text-4xl font-bold text-yellow-200">
              <CountUp start={0} end={65} duration={2.5} key={key} />k+
            </h3>
            <p className="text-sm mt-2">Automated Receipts Generated</p>
          </div>
          <div className="motion-safe:animate-[fadeInUp_0.6s_ease-out]">
            <h3 className="text-4xl font-bold text-yellow-200">
              <CountUp start={0} end={1} decimals={1} duration={2.5} key={key} /> lakh+
            </h3>
            <p className="text-sm mt-2">Automated Alert SMS Sent</p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default CompanyHome;
